import {
  Box,
  Heading,
  IconButton,
  LinkBox,
  LinkOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { XIcon } from '@/imports/ui/chakra/feather';

export const VideoPreview: React.FC<{
  html: string;
  providerUrl: string;
  href: string;
  target: string;
  title: string;
  description: string;
  canEdit: boolean;
  onCloseClick: () => void;
}> = (props) => (
  <Box position="relative">
    {props.canEdit && (
      <IconButton
        aria-label="hide preview"
        colorScheme="gray"
        size="xs"
        borderRadius="full"
        position="absolute"
        top={4}
        right={4}
        zIndex="1"
        onClick={props.onCloseClick}
        icon={<XIcon />}
      />
    )}

    <Box
      position="relative"
      height="0"
      pb="56.25%"
      overflow="hidden"
      borderTopLeftRadius="0.5rem"
      borderTopRightRadius="0.5rem"
      sx={{
        iframe: {
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'black',
        },
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: props.html }} />
    </Box>

    <LinkBox
      as={VStack}
      align="flex-start"
      p="4"
      border="1px"
      borderColor="gray.100"
      borderBottomLeftRadius="lg"
      borderBottomRightRadius="lg"
    >
      <Box color="gray.500" fontSize="12px" noOfLines={1}>
        {props.providerUrl}
      </Box>
      <LinkOverlay href={props.href} target={props.target}>
        <Heading as="h5" size="sm" noOfLines={1} color="gray.700">
          {props.title}
        </Heading>
      </LinkOverlay>
      <Text color="gray.500" noOfLines={1}>
        {props.description}
      </Text>
    </LinkBox>
  </Box>
);
